import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import './blocked-page.scss';
export const BlockedPage = () => {
    useEffect(() => {
        localStorage.clear();
        sessionStorage.clear();
        document.cookie = '';
    }, []);
    return (<section className="blocked-page">
      <div>
        <img className="blocked-page__img" src="/assets/icons/legacy/blockedUser.svg" alt="blocked"/>
        <p className="blocked-page__message">
          <FormattedMessage id="blocked-page.message"/>
        </p>
        <img className="blocked-page__logo" src="/assets/images/logo_doxyme.svg" alt="logo"/>
      </div>
    </section>);
};
